import React from 'react'

const CheckCircle = ({ width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <path
      fill="#2bd798"
      d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM8.958,14.41l-3.75-3.637L6.756,9.225l2.2,2.088,4.7-4.82,1.548,1.548Z"
    />
  </svg>
)

export default CheckCircle
